import type { SxProps } from '@mui/material';

export const variationNameDefault: SxProps = { flex: '1 1 100%' };

export const variationNameDisabled: SxProps = { flex: '1 1 auto' };

export const indicatorDefault: SxProps = { width: '32px', height: '32px', flex: '0 0 32px' };

export const indicatorDisabled: SxProps = {
  flex: '1 1 auto',
  textAlign: 'right',
  '& strong': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
};
